/** Global UI signals that don't belong to the house store (open sheets, etc.). */
import { useSyncExternalStore } from 'react';

function signal<T>(initial: T) {
  let v = initial;
  const ls = new Set<() => void>();
  return {
    get: () => v,
    set: (next: T) => {
      v = next;
      ls.forEach((fn) => fn());
    },
    subscribe: (fn: () => void) => {
      ls.add(fn);
      return () => ls.delete(fn);
    },
  };
}

export interface HistoryTarget {
  home: string;
  entityId: string;
  /** Climate entities: the room's own temperature sensor, plotted as "Room" instead of the stat's reading. */
  roomTempId?: string;
}

export const historyTarget = signal<HistoryTarget | null>(null);
export const openHistory = (home: string, entityId: string, opts: { roomTempId?: string | undefined } = {}): void =>
  historyTarget.set({ home, entityId, ...(opts.roomTempId && opts.roomTempId !== entityId ? { roomTempId: opts.roomTempId } : {}) });
export const closeHistory = (): void => historyTarget.set(null);
export function useHistoryTarget(): HistoryTarget | null {
  return useSyncExternalStore(historyTarget.subscribe, historyTarget.get, historyTarget.get);
}

export const switcherOpen = signal(false);
export function useSwitcherOpen(): boolean {
  return useSyncExternalStore(switcherOpen.subscribe, switcherOpen.get, switcherOpen.get);
}

/** Phone/tablet navigation drawer (shell/NavDrawer.tsx). */
export const drawerOpen = signal(false);
export function useDrawerOpen(): boolean {
  return useSyncExternalStore(drawerOpen.subscribe, drawerOpen.get, drawerOpen.get);
}

/** Home whose Alarm sheet is open (shell/Alarm.tsx), or null. */
export const alarmHome = signal<string | null>(null);
export function useAlarmHome(): string | null {
  return useSyncExternalStore(alarmHome.subscribe, alarmHome.get, alarmHome.get);
}
